import { useState, useEffect } from 'react';
import { ClientData } from '../types';
import { UseClientDataResult } from '../types';
import { ClientService } from '../services/clientService';

export function useClientData(): UseClientDataResult {
  const [clientData, setClientData] = useState<ClientData | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;

    const fetchClientData = async () => {
      // Yield to microtask queue so StrictMode cleanup can set cancelled=true before we start
      await Promise.resolve();
      if (cancelled) return;

      if (!window.__USER_FETCHED__) {
        await new Promise<void>((resolve) => {
          const interval = setInterval(() => {
            if (window.__USER_FETCHED__) {
              clearInterval(interval);
              resolve();
            }
          }, 50);
        });
      }

      if (cancelled) return;

      try {
        setLoading(true);
        setError(null);
        const fetchedClientData = await ClientService.getClientData();
        if (!cancelled) setClientData(fetchedClientData);
      } catch (err: unknown) {
        if (!cancelled) {
          const errorMessage = err instanceof Error ? err.message : 'Failed to load client data';
          setError(errorMessage);
          console.error('Error fetching client data:', err);
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    fetchClientData();

    return () => { cancelled = true; };
  }, []);

  return { clientData, loading, error };
}
